import React, { useState } from "react";
import "./Sidebar.css";
import SidebarItem from "./SidebarItem";
import items from "./Sidebar.json";
import LoginModal from "./LoginModal";

function Sidebar() {
  const [showLogin, setShowLogin] = useState(false);
  const [loggedIn, setLoggedIn] = useState(false);

  const handleSuperAdminClick = () => {
    if (!loggedIn) setShowLogin(true);
  };

  const handleLogin = () => {
    setLoggedIn(true);
    setShowLogin(false);
  };

  return (
    <>
      <div className="sidebarXXX">
        {items.map((item, index) => (
          <SidebarItem
            key={index}
            item={item}
            loggedIn={loggedIn}
            onSuperAdminClick={handleSuperAdminClick}
          />
        ))}
      </div>
      {showLogin && (
        <LoginModal onLogin={handleLogin} onClose={() => setShowLogin(false)} />
      )}
    </>
  );
}

export default Sidebar;
